import React from "react";

function Header() {
  return (
    <div className="w-full mx-auto max-w-md p-4 flex gap-4 items-center">
      <img src="/images/colorsmexico.png" alt="logo" className="w-[60px] h-auto" />
      <p>Day of the dead photomosaic</p>
    </div>
  );
}

export default Header;